import { render, staticRenderFns } from "./CreateResearchGroup.html?vue&type=template&id=165b3b7a&scoped=true&external"
import script from "./CreateResearchGroup.vue?vue&type=script&lang=js"
export * from "./CreateResearchGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateResearchGroup.scss?vue&type=style&index=0&id=165b3b7a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b3b7a",
  null
  
)

export default component.exports